import GridColumn from "@/classes/component-classes/GridColumn";

export class ViewShipment {

    constructor() {

            this.id = null,
            this.jobNumber = '',
            this.customerRef = '',
            this.mode = '',
            this.shipperName = '',
            this.shipperOrigin = '',

            this.shipperAddress = {
                addressLine1: '',
                addressLine2: '',
                addressLine3: '',
                addressLine4: '',
                postCode: '',
                country: '',
                telephone: ''
            },

            this.shipperContact = {
                name: '',
                position: '',
                telephone: ''
            },

            this.consigneeName = '',
            this.consigneeDestination = '',

            this.consigneeAddress = {
                addressLine1: '',
                addressLine2: '',
                addressLine3: '',
                addressLine4: '',
                postCode: '',
                country: '',
                telephone: ''
            },

            this.consigneeContact= {
                name: '',
                position: '',
                telephone: ''
            },

            this.consignmentDetails = {
                nop: null,
                weight: null,
                actualWeight: null,
                cube: null,
                description: ''
            },

            this.milestoneInformation = {

                dateColumns: [
                    new GridColumn('1', 'Pickup', 'pickupDate', '80', true),
                    new GridColumn('2', 'Closing', 'closingDate', '80', true),
                    new GridColumn('3', 'Departure', 'departureDate', '80', true),
                    new GridColumn('4', 'Arrival', 'arrivalDate', '80', true),
                    new GridColumn('5', 'Customs', 'customsDate', '80', true),
                    new GridColumn('6', 'Cleared', 'clearedDate', '80', true),
                    new GridColumn('7', 'Delivery', 'deliveryDate', '80', true)
                ],

                dates: [
                    {
                        pickupDate: {
                            est: '',
                            actual: '',
                            status: ''
                        },

                        closingDate: {
                            est: '',
                            actual: '',
                            status: '',
                        },

                        departureDate: {
                            est: '',
                            actual: '',
                            status: ''
                        },

                        arrivalDate: {
                            est: '',
                            actual: '',
                            status: ''
                        },

                        customsDate: {
                            est: '',
                            actual: '',
                            status: ''
                        },

                        clearedDate: {
                            est: '',
                            actual: '',
                            status: ''
                        },

                        deliveryDate: {
                            est: '',
                            actual: '',
                            status: ''
                        }

                    },
                ],

                milestones: [
                    {
                        id: '',
                        dateTime: '',
                        milestone: '',
                        comments: ''
                    }
                ]

            },

            this.detailedInformation = {

                incoTerms: 'No incoterms provided - N/A',

                air: {
                    flightNumber: '',
                    secondFlightNumber: '', // currently Flight2
                    awbNumber: '',
                    hawb: '',
                    flightDate: ''
                },

                sea: {
                    blNumber: '',
                    hbl: '',
                    vessel: '',
                    voyageNumber: '',
                    showTracking: false,
                    trackingUrl: ''
                },

                courier: {
                    consignmentNumber: '',
                    podName: '',
                    podDate: '',
                    podTime: '',
                    additionalRef: '', //currently CustRef2
                    value: '' // including currency
                }
            },

            this.warehouseHeaders = [
                // {
                //     id: '1',
                //     warehouseRef: 'PAUL4343',
                //     cube: '43477',
                //     supplier: 'Supplier',
                //     customerRef: 'Cust Ref',
                //     pieces: '3443',
                //     grossWeight: '2322.00'
                // },
                // {
                //     id: '2',
                //     warehouseRef: 'KNOBS',
                //     cube: '223477',
                //     supplier: 'Supplier',
                //     customerRef: 'Cust Ref',
                //     pieces: '123443',
                //     grossWeight: '2322.00'
                // },


            ],

            this.warehouseItems = [],

            this.containers = [
                {
                    sealNumber: '',
                    description: '',
                    nop: '',
                    grossWeight: '',
                    cube: '',
                    releaseRef: '',
                    depotDate: '',
                    reference: '',
                    deliveryDate: '',
                    loadingTime: ''
                }
            ],

            this.collectionAndDelivery =  [
                {
                    noteType: '',
                    customerRef: '',
                    deliveryDate: '',
                    status: '', // not showing on screen grab ??  (line 493, job details)
                    bookingRef: '',
                    company: '',
                    nop: '',
                    weight: '',
                    description: '',
                    marksAndNumbers: '',
                    PODName: '',
                    PODDate: ''
                }
            ],

            this.customs = [
                // {
                //     entryNumber: '',
                //     entryDate: '',
                //     mrn: ''
                // }
            ]



    }

}


